var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redirect-container"},[(_vm.loading)?_c('div',{staticClass:"loader d-flex flex-column align-items-center justify-content-center"}):(_vm.error)?_c('div',{staticClass:"error"},[_c('p',[_vm._v(_vm._s(_vm.error))]),_c('button',{on:{"click":_vm.closeWindow}},[_vm._v("Close")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }